/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

// Partial update of a license (= Organization). Note: there is NO license_name field — the
// org name is immutable here; only status / expiry / settings can change. SYSTEM_ADMIN only.
export type UpdateLicenseBody = {
  license_status?: string;
  expires_at?: string;
  starts_at?: string;
  language?: string;
  timezone?: string;
  customer_priority?: string;
  retention_days?: number;
};

// PATCH /xecguard/internal/v1/licenses/{license_id}
export default function updateLicense(
  { token, licenseId, body }: { token: string; licenseId: string; body: UpdateLicenseBody },
): Promise<InternalResponse> {
  return request()({
    url: `/xecguard/internal/v1/licenses/${licenseId}`,
    method: "PATCH",
    headers: authHeaders(token),
    data: body,
  }).then(
    (result: AxiosResponse): InternalResponse => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.response?.status ?? error.code,
    msg: error.message,
    success: false,
  }));
}
